import {AppUrls} from 'shared/config/model/urls';

import React, {useState} from 'react';
import cn from 'classnames';
import {t} from '@lingui/core/macro';

import { isTranslate } from 'shared/lib/lang';

import styles from './CookieConsentBanner.module.scss';

const CookieConsentBanner: React.FC = () => {
    const [isVisible, setIsVisible] = useState<boolean>(
        localStorage.getItem('cookieConsent') !== 'true',
    );

    const handleAccept = () => {
        localStorage.setItem('cookieConsent', 'true');
        setIsVisible(false);
    };

    if (!isVisible) {
        return null;
    }

    return (
        <div className={cn(
            styles.container,
            styles[isTranslate() ? 'enColor' : 'ruColor'],
        )}>
            <span>
                {t`Используя сайт, вы предоставляете`}
                <a
                    href={AppUrls.PRIVACY}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {t ` согласие `}
                </a>
                {t`на обработку ваших персональных данных с помощью сервисов веб-аналитики`}
            </span>
            <button
                type="button"
                onClick={handleAccept}
                className={cn(
                    styles.button,
                    styles.colorButton,
                )}
            >
                {t`Окей`}
            </button>
        </div>
    );
};
export default CookieConsentBanner;